








































































import { Component, Vue } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { SocialMediaSettings } from '@/interfaces'

@Component({
  components: {
    PageHead,
  },
})
export default class SettingsSocialMedia extends Vue {
  pageTitle = 'Social Media Settings'
  callInProgress = false
  settings: SocialMediaSettings = null

  mounted() {
    this.fetchSocialMediaSettings()
  }

  public async fetchSocialMediaSettings() {
    this.callInProgress = true
    try {
      this.settings = await Api.getSocialMediaSettings()
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async setSocialMediaSettings() {
    this.callInProgress = true
    try {
      await Api.setSocialMediaSettings(this.settings)
      this.callInProgress = false
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Social Media Settings Saved.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}

